import { render, staticRenderFns } from "./RecordTables.vue?vue&type=template&id=48a70ee8&scoped=true"
import script from "./RecordTables.vue?vue&type=script&lang=js"
export * from "./RecordTables.vue?vue&type=script&lang=js"
import style0 from "./RecordTables.vue?vue&type=style&index=0&id=48a70ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a70ee8",
  null
  
)

export default component.exports